import { TextFieldProps } from '@material-ui/core/TextField'
import { useController, useFormContext } from 'react-hook-form'
import { TextArea } from 'common/components'
import { FormErrorMessage } from './FormErrorMessage'

interface InputProps extends Omit<TextFieldProps, 'onChange' | 'inputRef' | 'value' | 'error'> {
  name: string
  defaultValue?: string
}

export const FormTextArea = ({ name, defaultValue, ...rest }: InputProps): JSX.Element => {
  const {
    formState: { errors }
  } = useFormContext()

  const {
    field: { ref, value, ...fieldProps },
    fieldState: { error }
  } = useController({
    name,
    defaultValue
  })

  return (
    <TextArea
      {...rest}
      {...fieldProps}
      value={value}
      inputRef={ref}
      error={!!error}
      helperText={<FormErrorMessage errors={errors} name={name} />}
    />
  )
}
